import SplitScreen from "components/common/SplitScreen";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";

import Container from "components/common/CustomContainer";
import { isEmpty } from "lodash";
import { getLoggedInUserDetails } from "utils/CommonFunctions";
import SuggestedPlans from "../MyDashboard/SuggestedPlans";
import ReleaseHighlight from "../ReleaseHighlight";
import "./HotelUserDashboard.scss";
import { reset } from "./HotelUserDashboard.slice";
import Home from "./PropertyOverview/Home";
import RecentlyViewed from "./RecentlyViewed";

export default function HotelUserDashboard() {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const externalHltId = searchParams.get("member");
  const { isLeadership, isAbovePropertyUser } = useAppSelector((state) => state.app.loggedInUserDetails);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, []);

  const loggedInUserDetails = getLoggedInUserDetails();

  return (
    <div className="hotel_user_dashboard">
      {!isEmpty(loggedInUserDetails) && (
        <SplitScreen
          direction="horizontal"
          fullHeight={true}
          firstClassName="custom-pane-left"
          secondClassName="custom-pane-right"
          secondScroll={false}
          firstContent={<Home />}
          secondContent={
            searchParams.get("parentTab") === "My Dashboard" || externalHltId || !isLeadership ? (
              <>
                {!isAbovePropertyUser && <ReleaseHighlight />}
                <Container className="suggested-plans" scroll="full">
                  <SuggestedPlans />
                </Container>
                <Container className="recently-viewed" scroll="full">
                  <RecentlyViewed />
                </Container>
              </>
            ) : (
              false
            )
          }
        />
      )}
    </div>
  );
}
